module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("kjrCT"))).then(() => parcelRequire('401YU'));